import type { Boundaries } from '@widgets/shared/types'

export type BoundariesPaddingsOptions = {
  alignX?: boolean
  alignY?: boolean
}

export const widgetPadding = 8

export const addPaddingsToBoundaries = (
  { width, height }: Boundaries,
  { alignX, alignY }: BoundariesPaddingsOptions = {},
  padding = widgetPadding,
): Boundaries => ({
  width: width + (alignX ? 1 : 2) * padding,
  height: height + (alignY ? 1 : 2) * padding,
})
